<template>
  <div style="padding: 50px 150px;">
    <el-container>
      <el-header>定向包</el-header>
      <el-main>
        <el-row>
          <el-col :span="8">
            <!-- <div class="grid-content bg-purple-dark"></div> -->
            <div>
              定向包    <el-input placeholder="请输入定向包名字" v-model="btgjc" style="width: 200px;" size="small"></el-input>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="display: flex;align-items: center;height: 100%;">
               <!-- <div class="grid-content bg-purple-dark"></div> -->
            推广目标：
            <el-radio v-model="radio" label="1">普通网址</el-radio>
            <el-radio v-model="radio" label="2">快应用/快游戏</el-radio>
            计划类型：<el-radio v-model="radio2" label="1">非商店</el-radio>
            <el-radio v-model="radio2" label="2">联盟</el-radio>
            </div>
          </el-col>
          <el-col :span="8">
            <!-- <div class="grid-content bg-purple-dark"></div> -->

          </el-col>
          <el-col :span="4">
            <!-- <div class="grid-content bg-purple-dark"></div> -->

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" >
            <el-button type="primary" size="small" icon="el-icon-search">搜索</el-button>


          </el-col>
          <el-col :span="2" size="mini">
            <el-button size="small" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" >
            <el-button type="primary" size="small" plain icon="el-icon-plus">新增</el-button>
          </el-col>
          <el-col :span="2" size="mini">
            <el-button size="small"  plainicon="el-icon-edit">修改</el-button>
          </el-col>
          <el-col :span="2" size="mini">
            <el-button size="small" type="danger" plain icon="el-icon-delete">删除</el-button>
          </el-col>

        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      btgjc: '',
      radio: 1,

    }
  }
}
</script>



<style scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}</style>
  


// WEBPACK FOOTER //
// src/components/login/audience.vue